import axios from "axios";

// @TODO remove this after completing development
const BASE_URL = window.location.hostname.includes('localhost')
  ? 'http://localhost:8080'
  : 'https://naija-election-candidates-2023-2kfcnvmreq-ew.a.run.app/';

function fetchCandidatesByPositionForUpcomingElection({lat, lng, dummy}) {
  return axios.get(`${BASE_URL}/find/upcoming?position=${lat},${lng}&dummy=${dummy}`);
}

function fetchCandidatesByPosition(lat, lng, year) {
  return axios.get(`${BASE_URL}/find?position=${lat},${lng}&year=${year}`);
}

function findPollingUnit(code) {
  return axios.get(`${BASE_URL}/find/polling-unit?code=${code}`);
}

// @Deprecated
// Use fetchCandidatesByPosition() instead
function getData(lat, lng) {
  return this.fetchCandidatesByPosition(lat, lng, '2023')
}

function reverseGeocode(lat, lng) {
  return axios.get(`${BASE_URL}/find/reverse?position=${lat},${lng}`);
}

function registerPhoneNumber(phone) {
  return axios.post(`${BASE_URL}/users/register`, { phone });
}

function verifyOTP({ phone, code, pinId }) {
  return axios.post(`${BASE_URL}/users/verify-otp`, { phone, code, pinId });
}

function subscribeEmail(email) {
  return axios.post(`${BASE_URL}/users/subscribe`, { email});
}

const API = {
  fetchCandidatesByPositionForUpcomingElection,
  fetchCandidatesByPosition,
  getData,
  reverseGeocode,
  subscribeEmail,
  registerPhoneNumber,
  verifyOTP,
  findPollingUnit
}

export default API;
